/* Reuse the theme's native quick view and Globo's Cuff form for paid options. */
(async () => {
  'use strict';
  if (document.readyState === 'loading') await new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, { once: true }));
  await customElements.whenDefined('quick-view');
  const drawer = document.getElementById('Product-Drawer');
  if (!drawer || !customElements.get('quick-view')) return;
  if (document.querySelector('script[data-daluca-cuff-popup]')?.dataset.productHandle === 'the-cuff') document.body.classList.add('dl-cuff-product');
  const drawerTitle = drawer.querySelector('.side-panel-header .h4');
  const defaultTitle = window.DaLucaI18n.chainText(() => (drawerTitle), [{kind:"text", optional:true}]);
  let opener, trigger, product, preparedForm, observer, timer;
  const root = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: document.querySelector('script[data-daluca-cuff-popup]')?.dataset.currency || 'USD'
  }).format(cents / 100);
  const resumeBuilder = (host, form) => {
    if (!window.DaLucaCustomCartAdapter?.isReady?.() || !trigger ||
      !window.DaLucaCustomCartAdapter.getBuilder()?.contains(trigger)) return;
    const render = host.renderContents;
    if (typeof render !== 'function') return;
    const buildTrigger = trigger;
    const scrollTop = window.scrollY;
    host.renderContents = function (state) {
      if (this.form !== form || !drawer.contains(this) ||
        !window.DaLucaCustomCartAdapter?.isReady?.()) return render.call(this, state);
      this.getSectionsToRender().forEach(section => {
        const target = document.getElementById(section.id);
        const html = state.sections?.[section.section];
        if (!target || !html) return;
        const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
        if (replacement) (target.querySelector(section.selector) || target).innerHTML = replacement.innerHTML;
      });
      drawer.querySelector('.side-panel-close')?.click();
      const card = buildTrigger.closest('[data-daluca-care-proxy]') || buildTrigger.parentElement;
      let status = card.querySelector('[data-daluca-cuff-added]');
      if (!status) {
        status = document.createElement('p');
        status.dataset.dalucaCuffAdded = '';
        status.setAttribute('role', 'status');
        status.style.gridColumn = '1 / -1';
        card.appendChild(status);
      }
      window.DaLucaI18n.setText(status, 'The Cuff was added to your cart. Continue building your strap.');
      buildTrigger.focus({ preventScroll: true });
      window.scrollTo({ top: scrollTop, behavior: 'instant' });
    };
  };

  const prepare = () => {
    if (!drawer.classList.contains('dl-cuff-popup') || !product) return;
    const form = drawer.querySelector('product-form form');
    const wristGroup = form?.querySelector('.gpo-element[data-element-id="dropdown-1"]');
    const radios = Array.from(wristGroup?.querySelectorAll('input[type="radio"]') || []);
    const branding = form?.querySelector('select[data-field-name="DA LUCA Rivets"]');
    const submit = form?.querySelector('.single-add-to-cart-button');
    if (!form || !radios.length || !branding || !submit) return;
    if (preparedForm === form) return;
    preparedForm = form;
    clearTimeout(timer);
    drawer.classList.add('dl-cuff-ready');
    const host = form.closest('product-form');
    resumeBuilder(host, form);
    let ancestor = host.parentElement;
    while (ancestor && ancestor.id !== 'Product-Drawer-Content') { ancestor.classList.add('dl-cuff-form-path'); ancestor = ancestor.parentElement; }
    host.classList.add('dl-cuff-form');
    const quantity = form.querySelector('[name="quantity"]');
    if (quantity) quantity.value = '1';
    const select = document.createElement('select');
    select.id = 'dl-cuff-wrist'; select.required = true;
    select.setAttribute('aria-label', 'Wrist size');
    select.add(new Option('Choose your wrist size', ''));
    radios.forEach((radio, index) => {
      const label = radio.nextElementSibling;
      select.add(new Option((window.DaLucaI18n.chainText(() => (label), [{kind:"text", optional:true}]) || radio.value).replace(/\s+/g, ' ').trim(), String(index)));
    });
    wristGroup.querySelector('.gpo-dropdown').hidden = true;
    const wristControl = document.createElement('div');
    wristControl.className = 'dl-cuff-wrist-control';
    const wristValue = document.createElement('span');
    wristValue.className = 'dl-cuff-wrist-value';
    wristValue.setAttribute('aria-hidden', 'true');
    wristControl.append(select, wristValue);
    wristGroup.appendChild(wristControl);
    wristGroup.querySelector('.gpo-label')?.setAttribute('for', select.id);
    branding.required = true;
    const brandLabel = branding.closest('.gpo-element')?.querySelector('.label-content');
    if (brandLabel) window.DaLucaI18n.setText(brandLabel, 'DA LUCA on your cuff');
    const helpControls = [];
    const closeHelp = () => helpControls.forEach(({ button, help }) => {
      button.setAttribute('aria-expanded', 'false');
      help.hidden = true;
    });
    form.querySelectorAll('.gpo-label .label-tooltip').forEach((tooltip, index) => {
      const label = tooltip.closest('.gpo-label');
      const content = tooltip.querySelector('.label-tooltip__content');
      const icon = tooltip.querySelector('svg');
      if (!label || !content || !icon) return;
      const row = document.createElement('div');
      row.className = 'dl-cuff-label-row';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'dl-cuff-help-toggle';
      const help = document.createElement('div');
      help.id = 'dl-cuff-help-' + index;
      help.className = 'dl-cuff-help-text';
      help.hidden = true;
      help.setAttribute('role', 'note');
      window.DaLucaI18n.setText(help, window.DaLucaI18n.sourceText(content).trim());
      if (!label.id) label.id = 'dl-cuff-help-label-' + index;
      button.setAttribute('aria-labelledby', label.id);
      button.setAttribute('aria-controls', help.id);
      button.setAttribute('aria-expanded', 'false');
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');
      button.appendChild(icon);
      tooltip.remove();
      label.before(row);
      row.append(label, button);
      row.after(help);
      helpControls.push({ button, help });
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const open = help.hidden;
        closeHelp();
        help.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
      });
    });
    form.addEventListener('change', closeHelp);
    const custom = document.createElement('div');
    custom.className = 'dl-cuff-custom-size'; custom.hidden = true;
    window.DaLucaI18n.setHtml(custom, '<label for="dl-cuff-custom-size">Your wrist circumference</label><input id="dl-cuff-custom-size" name="properties[Custom wrist circumference]" type="text" maxlength="80" placeholder="For example, 10.5 inches or 267 mm" disabled><small>Include inches or mm with your measurement.</small>');
    wristGroup.after(custom);
    const customInput = custom.querySelector('input');
    const total = document.createElement('div'); total.className = 'dl-cuff-total';
    window.DaLucaI18n.setHtml(total, '<span>Cuff total</span><strong></strong>');
    submit.before(total);
    const error = document.createElement('p'); error.className = 'dl-cuff-error';
    error.setAttribute('role', 'alert'); error.hidden = true; submit.before(error);
    const update = () => {
      radios.forEach((radio, index) => {
        let label = radio.value;
        if (label.includes('(') && !label.includes(')')) label += ')';
        const surcharge = Math.round(Number(radio.dataset.addonPrice || 0) * 100);
        window.DaLucaI18n.setText(select.options[index + 1], label + (surcharge ? ' (+' + money(surcharge) + ')' : ''));
      });
      wristValue.textContent = select.selectedOptions[0]?.textContent || '';
      const selected = select.value === '' ? null : radios[Number(select.value)];
      const isCustom = selected?.value === 'Custom Wrist Size';
      custom.hidden = !isCustom; customInput.disabled = !isCustom; customInput.required = !!isCustom;
      window.DaLucaI18n.setText(total.querySelector('strong'), money(product.variants[0].price + Math.round(Number(selected?.dataset.addonPrice || 0) * 100)));
      error.hidden = true;
    };
    select.addEventListener('change', () => { radios[Number(select.value)]?.click(); update(); });
    branding.addEventListener('change', update);
    form.addEventListener('submit', event => validate(event), true);
    function validate(event) {
      const missing = select.value === '' ? select : !branding.value ? branding : customInput.required && !customInput.value.trim() ? customInput : null;
      if (!missing) return true;
      event.preventDefault(); event.stopImmediatePropagation();
      window.DaLucaI18n.setText(error, missing === select ? 'Please choose your wrist size.' : missing === branding ? 'Please choose whether to keep DA LUCA on your cuff.' : 'Please enter your wrist measurement, including inches or mm.');
      error.hidden = false; missing.focus(); return false;
    }
    form._dlCuffValidate = validate;
    form._dlCuffRefresh = update;
    update();
  };
  window.addEventListener('click', event => {
    if (!drawer.classList.contains('dl-cuff-popup')) return;
    if (event.target.closest('#Product-Drawer .single-add-to-cart-button')) {
      if (!preparedForm) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      preparedForm._dlCuffValidate?.(event);
    }
  }, true);
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-daluca-cuff-options]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;
    trigger = button; trigger.disabled = true;
    try {
      if (!product) {
        const response = await fetch(root + 'products/the-cuff.js');
        if (!response.ok) throw new Error('Unable to load cuff options.');
        product = await response.json();
      }
      if (!opener) {
        opener = document.createElement('quick-view');
        opener.dataset.productHandle = 'the-cuff';
        opener.hidden = true; document.body.appendChild(opener);
      }
      drawer.classList.add('dl-cuff-popup'); drawer.classList.remove('dl-cuff-ready'); preparedForm = null;
      if (drawerTitle) window.DaLucaI18n.setText(drawerTitle, 'Add The Cuff');
      opener.handleClick(event);
    } catch (error) {
      window.DaLucaQuantityFeedback?.show('Cuff options could not load. Please try again.');
    } finally { trigger.disabled = false; }
  });
  document.addEventListener('panel:closed', event => {
    if (event.detail?.panel !== drawer || !drawer.classList.contains('dl-cuff-popup')) return;
    observer?.disconnect();
    clearTimeout(timer);
    preparedForm = null;
    drawer.classList.remove('dl-cuff-ready');
  });
  document.addEventListener('quick-view:open', event => {
    if (event.detail?.productHandle !== 'the-cuff') {
      observer?.disconnect(); clearTimeout(timer);
      drawer.classList.remove('dl-cuff-popup', 'dl-cuff-ready');
      if (drawerTitle) window.DaLucaI18n.setText(drawerTitle, defaultTitle);
      return;
    }
    if (!drawer.classList.contains('dl-cuff-popup')) return;
    observer?.disconnect();
    observer = new MutationObserver(prepare);
    observer.observe(drawer, { childList: true, subtree: true });
    const form = drawer.querySelector('product-form form');
    if (form && !form.querySelector('.gpo-app') && typeof window.GPOConfigs?.loadMainScripts === 'function') {
      window.GPOConfigs.loadMainScripts(product, window.GPOConfigs.customer, form).then(() => { prepare(); form._dlCuffRefresh?.(); }).catch(() => {});
    }
    prepare();
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (drawer.classList.contains('dl-cuff-ready')) return;
      const content = drawer.querySelector('#Product-Drawer-Content');
      if (content) window.DaLucaI18n.setHtml(content, '<p role="alert">Cuff options could not load. Please close this window and try again.</p>');
    }, 20000);
  });
})();

